import React, { createContext, useContext, useState, useEffect } from "react"; 
import AuthComponent from "./AuthComponent";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const user_email = sessionStorage.getItem("useremail");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState('')
  const [isLoading, setIsLoading] = useState(true);  

  useEffect(() => { 
    if (user_email) {
      const authStatus = sessionStorage.getItem("isAuthenticated") === "true";  
      setIsAuthenticated(authStatus);
      setUserEmail(user_email)
    }else {
      setUserEmail("")
    }
    setIsLoading(false);
  }, [user_email]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
console.log('ISAUTH::::', isAuthenticated)
  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated, userEmail, setUserEmail }}>
      {isAuthenticated ? children : <AuthComponent />}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
